
import { NL_Subeler } from './../../../models/NL_Subeler';
import { BllSubeler } from './../../../providers/bll/bll-subeler';
import { Component } from '@angular/core';
import { NavController, NavParams, ActionSheetController } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';


@Component({
  selector: 'page-subeler',
  templateUrl: 'subeler.html',
})
export class SubelerPage {
  subeler = [];
  subedegisimi:any={ID:"",SubeAdi:"",SubeAdres:""};
  constructor(public navCtrl: NavController,
    public ortak: Ortak,
    public actionSheetCtrl: ActionSheetController,
    public navParams: NavParams) {
  }
  ionViewDidLoad() {
    this.SubeleriGetir();
  }
  SubeleriGetir() {
    var bllsube = new BllSubeler();
    bllsube.getAll().then(a => {
      var sonuc = <any>a;
      this.subeler = sonuc;
    })
  }

  subekaydet() {
    this.ortak.alertSubeKaydet().then(a => {
      var sonuc = <any>a;
      var values = sonuc.values;
      var subead = values.subeadi;
      var subeadress = values.subeadres;
      var bllsubes = new BllSubeler();
      var subeekle = new NL_Subeler();
      subeekle.SubeAdi = subead;
      subeekle.SubeAdres = subeadress;
      bllsubes.add(subeekle);
      this.SubeleriGetir();
    })

  }
  subesil(sube) {
    var bllsube = new BllSubeler();
    if (this.subeler.length > 1) {
      bllsube.delete({ ID: sube.ID }).then(a => {
        this.ortak.showBasicAlert("Başarılı", "Şube Başarıyla Silindi");
        bllsube.getAll().then(a=>{
          var sonuc=<any>a;
          this.subedegisimi=sonuc[0];
          this.ortak.storageServisBilgisiEkle(this.subedegisimi);
        })
       
        this.SubeleriGetir();
      }).catch(x => {

      });
    }
    else {
      this.ortak.showBasicAlert("Hata", "En az 1 adet şube kaydı olması gerekiyor");
    }

  }
  Islemler(sube) {
    const actionSheet = this.actionSheetCtrl.create({
      title: 'Cari  İşlemleri',
      buttons: [

        {
          text: 'Şubeyi  Sil',
          handler: () => {
            this.subesil(sube);

          }
        }, {
          text: 'İptal ',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }


}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/subeler/subeler.ts